import { useCallback, useEffect, useRef } from 'react';
import debounce from 'lodash.debounce';

// todo: add finished state to remove eventlistener after loading all data
export default function useInfiniteLoading({
                                               scrollingElementSelector,
                                               loaderMethod,
                                               toBeWatchedData,
                                               loading,
                                               isDeactive
                                           }: {
    scrollingElementSelector?: any;
    loaderMethod?: any;
    toBeWatchedData?: any;
    loading?: any;
    isDeactive?: any;
}) {

    useEffect(() => {
        if (!isDeactive) {
            const scrollingElement = document.querySelector(scrollingElementSelector);
            if (
                toBeWatchedData &&
                scrollingElement?.scrollHeight <= scrollingElement?.clientHeight
            ) {
                setTimeout(loaderMethod, 0);
            }

            scrollingElement?.addEventListener('scroll', debouncedHandleScroll);
            return () => {
                loaderMethodCalled.current = false;
                scrollingElement?.removeEventListener('scroll', debouncedHandleScroll);
            };
        }
    }, [toBeWatchedData, isDeactive]);

    const loaderMethodCalled = useRef(false);

    const debouncedHandleScroll = useCallback(debounce(() => {
        const scrollingElement = document.querySelector(scrollingElementSelector);
        const LOAD_MORE_ITEMS_THRESHOLD = 40 / 100;
        const shouldLoadNewItems =
            scrollingElement?.scrollTop >
            (scrollingElement?.scrollHeight - scrollingElement?.clientHeight) *
            LOAD_MORE_ITEMS_THRESHOLD;
        if (shouldLoadNewItems && !loading && !loaderMethodCalled.current) {
            setTimeout(loaderMethod, 0);
            loaderMethodCalled.current = true;
        }
    }, 100) as () => void, [loading, toBeWatchedData]);
}